import { render } from "./HousingComplexes.vue?vue&type=template&id=61ab3dd1"
import script from "./HousingComplexes.vue?vue&type=script&lang=js"
export * from "./HousingComplexes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__